import  { useState   } from "react";
import {  useSelector } from "react-redux";


import { useContrats  } from "../../state/reactquery";


import { axios_jeresilie_sendLetter_nofile,axios_jeresilie_sendLetter_withfile } from "../../axios/axios_jeresilie";

import compagniesmotifs from '../../utils/jeresiliecompagniesmotifs.json';
import { dateconvert } from "../../utils/utils_dates";
import {listchampsclient} from "../../utils/jeresilie";

import ButtonSimple from "../Buttons/ButtonSimple";

import './ContratWinEasyResil.scss';

const REQUIRED_FIELDS= ['lastname','firstname', 'postCode','city','address','contractNumber','echeancePrincipale','nouvelAssureur'];

const classNames = require('classnames'); 


function ContratWinEasyResil(){
    const {liste_compagnies, liste_motifs} = compagniesmotifs ;

    const lead = useSelector(state=>state.lead.leadactu);
    const {data: contrats} = useContrats(lead?.email,lead?.courtier) ; 
    const lastcontrat =  contrats?.sort((a,b)=> new Date(b.date_insert) - new Date(a.date_insert))?.[0];

//     const initdatas = {
//     "gender": "Monsieur",
//     "lastname": "SELLAM",
//     "firstname": "Simone",
//     "address": "14 Rue de Thionville, 57440 Angevillers, France",
//     "addressComplement": null,
//     "postCode": "57440",
//     "city": "Angevillers",
//     "email": "test@mutuello.email",
//     "country": "FRANCE",
//     "kindOfContract": 6,
//     "cancelReason": 20,
//     "compagnie": "+Simple.Fr",
//     "recipient": "925",
//     "contractNumber": "QWERTY1233",
//     "echeancePrincipale": "2026-10-02",
//     "nouvelAssureur": "DFZGHDSFGHSH"
// }

    const initdatas = {"gender": (lead.civilite==='M'||lead.civilite==='M.')?'Monsieur':'Madame',
                    "lastname":lead.nom,"firstname":lead.prenom,
                    "address":lead.adresse,"addressComplement": lead.complement_adresse,
                    "postCode":lead.code_postal,"city": lead.ville,
                    "email": lead.email, "country": "FRANCE","kindOfContract": 6,"cancelReason":liste_motifs?.[0]?.id,
                    "compagnie":liste_compagnies?.[0]?.name,"recipient":liste_compagnies?.[0]?.id?.toString(),"contractNumber":lastcontrat?.num_contrat||"" ,
                    "echeancePrincipale": dateconvert(lead.date_effet)||(new Date()).toLocaleDateString("fr-FR") }

    const [datas,setDatas] = useState(initdatas) ; 
    
    const [isLoading, setIsLoading ] = useState(false) ; 
    const [files, setFiles] = useState([]);
    
   const disablebutton = REQUIRED_FIELDS.some(key => !datas[key]?.trim()) ;
   const test = REQUIRED_FIELDS.map(key => !datas[key]?.trim()) ;
   console.log("TEST", test ,disablebutton) ;

    const changechmap =(e)=>{setDatas({...datas,[e.target.name]: e.target.value }); }
    
    const grplabelinput = (x,label)=>( <div key={x}  className="containerinputlabelresil tiers" >
                                            <div className="inputtextelabelresil">{label}</div>
                                            <input id={x}  name={x}  value={datas[x]}  
                                                    type={x==='echeancePrincipale' ?"date":"text"} 
                                                    onChange={changechmap}
                                                    className="inputretractation"  />
                                        </div>) ;


    const changeSelectCompagnie =(e)=>{const nom_compagnie = liste_compagnies.filter(x=>x.id.toString()===e.target.value)[0]?.name ;  
        setDatas({...datas,recipient:e.target.value,compagnie:nom_compagnie }) ;
    }

    const handleFile = (e) => {setFiles(files=>[...files,...e.target.files]);};

    const envoiresiliation = async () => {
  
        setIsLoading(true) ;
        const hasFile = files && files.length > 0;
        datas["cancelReason"] =  parseInt(datas?.cancelReason) ;

        if (hasFile) {
            const data = new FormData();
            data.append('lead', JSON.stringify(lead));
            data.append('datas', JSON.stringify(datas));

            const file = files[0];
            const nomfichier = file.name.split('.')[0];
            const extension = file.name.split('.')[1];
            data.append('file', file, `/${nomfichier}.${extension}`);

            await axios_jeresilie_sendLetter_withfile(data);
        } else {  await axios_jeresilie_sendLetter_nofile({lead,datas}); }

        setIsLoading(false) ;
        setDatas(initdatas) ; 
}


return(<div  className="jeresilie">
            {isLoading===true ?<div className="loadingresil" >  Le mandat de résiliation est parti.<br/>
                                    À la suite de la signature de celui-ci, notre partenaire Easyresil enverra à la compagnie indiquée la résiliation par recommandé avec accusé de réception.      
                            </div>:<div className="jeresilie_btngrp" >
                <div  className="containerlabelinput"  >
                    <div className="inputtextelabelresil">Compagnies</div>
                        {<select value={datas?.recipient||1} className='selectcompgamme' onChange={changeSelectCompagnie} >
                                  {liste_compagnies.map((y)=><option key={y.id} id={y.id} value={y.id} >{y.name}</option>)}
                        </select>}
                </div> 
                <div  className="containerlabelinput"  >
                    <div className="inputtextelabelresil">Motifs de résiliation</div>
                        <select value={datas.cancelReason||''} className='selectcompgamme' name="cancelReason" onChange={changechmap} >
                                {liste_motifs.map((y)=><option key={y.id} name={y.id} value={y.id} >{y.name}</option>)}
                         </select>
                </div> 
                <div className="gendergroup" > 
                <div  className="gendergroup_buttons" >
                    <button id='Monsieur' name="gender" value="Monsieur" className={classNames('button button_gender',{'button_gender_selected': datas['gender']==='Monsieur'})} onClick={changechmap}>Monsieur</button>
                    <button id='Madame'  name="gender" value="Madame"  className={classNames('button button_gender',{'button_gender_selected': datas['gender']==='Madame'})} onClick={changechmap}>Mme / Melle</button>
                </div>
             </div>
                {Object.keys(listchampsclient).map(x=>( grplabelinput(x,listchampsclient[x]) )) }
                            
                  <div className="contratwindevis_upload">
                        <input type='file' single  id='uploaddevis' className="uploadvalidcontrat_input"  onChange={handleFile} />
                  </div>

                  <div className="groupe_boutons">
                      <ButtonSimple  texte="Envoyer" containerbouton='fullbuton' disable={disablebutton} color='bouton_color_orange' size='bouton_size_normal' onclick={envoiresiliation}   />      
                </div>     
             
                </div>}
        </div>) ;
}


export default ContratWinEasyResil
